import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createCarrier } from 'API/Carriers/createCarrier';

const useCreateCarrier = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const create = async (carrierData) => {
        const response = await createCarrier(carrierData);
        return response.data;
    };

    return useMutation({
        mutationFn: create,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['Carriers'] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useCreateCarrier;
